import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { Environment } from '../environment/environment';

@Injectable({ providedIn: 'root' })
export class SentryService {
  private readonly environment = inject(Environment);

  init(): void {
    Sentry.init({
      dsn: this.environment.sentryDSN,
      denyUrls: [/localhost/],
      attachStacktrace: true,
      // HTTP failures are already reported with endpoint grouping by the error interceptors via captureHttpError
      beforeSend: (event, hint) => (hint.originalException instanceof HttpErrorResponse ? null : event),
    });
  }

  captureError(error: unknown): void {
    if (window.location.origin.includes('localhost')) {
      return;
    }
    Sentry.captureException(error);
  }

  captureHttpError(req: HttpRequest<unknown>, error: HttpErrorResponse, userId: string | undefined): void {
    const endpoint = new URL(req.url, window.location.origin).pathname;
    const sentryError = new Error(`${req.method} ${endpoint}`);
    sentryError.name = `HTTP ${error.status}`;

    Sentry.captureException(sentryError, {
      fingerprint: [req.method, endpoint, String(error.status)],
      tags: { endpoint, status: error.status, reason: error.error?.reason },
      extra: { error, userId, requestBody: JSON.stringify(req.body) },
    });
  }
}
